import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import RouteErrorFallback from '#components/error/RouteErrorFallback.tsx';
import { LivemonitorWidgetPage } from '#pages/LivemonitorWidgetPage.tsx';

import WidgetLayout from '../layout/WidgetLayout.tsx';
import { routes } from './routes.ts';

const routesFromElements = createRoutesFromElements(
    <Route element={<WidgetLayout />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.LIVEMONITOR} element={<LivemonitorWidgetPage />} />

        <Route path='*' element={<Navigate to={routes.LIVEMONITOR} />} />
    </Route>
);

export const widgetRouter = createHashRouter(routesFromElements);
